import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface ProductNumberFormValues {
  sw_product_no: string;
  name: string;
}

export const productNumberDefaultValues: ProductNumberFormValues = {
  sw_product_no: '',
  name: '',
};

export const productNumberSchema = yup.object({
  sw_product_no: yup
    .string()
    .required('Product number is required'),
  name: yup.string().required('Description is required'),
});

export function useProductNumberForm(initialValues?: Partial<ProductNumberFormValues>) {
  return useForm<ProductNumberFormValues>({
    mode: 'onSubmit',
    resolver: yupResolver(productNumberSchema),
    defaultValues: { ...productNumberDefaultValues, ...initialValues },
  });
}
